import { ReactNode } from 'react';
import { IconType } from 'react-icons';
import Link, { LinkProps, LinkTypes } from '../../../components/Link';
import Typography from '../../../components/Typography';
import Section from '../../../components/Section';
import styles from './Footer.module.scss';

export type FooterItem<T extends LinkTypes = 'link'> = {
  icon?: IconType;
  type?: T;
} & Omit<LinkProps<T>, 'type'>;

export interface FooterProps {
  sections: {
    label: ReactNode;
    items: FooterItem[];
  }[];
}

function Footer({ sections }: FooterProps) {
  return (
    <Section as="footer" className={styles.container}>
      {sections.map((section, key) => (
        <div className={styles.section} key={key}>
          <Typography textType="p2" textWeight="bold" as="p">
            {section.label}
          </Typography>
          <hr className={styles.line} />
          <ul className={styles.items}>
            {section.items.map(({ icon: Icon, ...linkProps }, key) => {
              return (
                <Typography textType="p2" key={key} as="li">
                  <Link
                    {...linkProps}
                    type={linkProps.type ?? 'link'}
                    className={styles.link}
                  >
                    {Icon && <Icon className={styles.icon} />}
                    <span>{linkProps.children}</span>
                  </Link>
                </Typography>
              );
            })}
          </ul>
        </div>
      ))}
    </Section>
  );
}

export default Footer;
